import { colors } from '../../theme';

const mention = {
  fontWeight: 500,
  color: colors.mention,
};

const styles = {
  // The spaces next to a mention stay, even in a flex row.
  text: {
    whiteSpace: 'pre-wrap',
  },
  mention,
  mentionButton: {
    ...mention,
    p: 0,
    border: 0,
    backgroundColor: 'transparent',
    font: 'inherit',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
};

export default styles;
